import { useState } from 'react'
import { useDispatch } from 'react-redux'
import Textarea from 'react-textarea-autosize'
import { useLocation } from 'react-router'
import * as routerActions from 'connected-react-router'
import cn from 'clsx'

// Components
import { Avatar } from 'kit'
import { Button } from '@tracklib/kit'

// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'

import styles from './addcomment.css'

type AddCommentProps = {
  isReply?: boolean
  isEdit?: boolean
  onCommentDone: (arg0: string) => void
  isLoading?: boolean
  isCommenting: boolean
  commentText: string
  handleCommentStart?: () => void
  handleCommentCancel?: () => void
  handleUpdateText: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const AddComment = ({
  onCommentDone,
  handleUpdateText,
  isReply,
  isEdit,
  isLoading,
  isCommenting,
  commentText,
  handleCommentStart,
  handleCommentCancel,
}: AddCommentProps): JSX.Element => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const isAuthenticated = useIsAuthenticated()
  const [text, setText] = useState('')
  const updateText = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    handleUpdateText(e)
    setText(e.target.value)
  }
  const renderButtonText = (): string => {
    if (isReply) {
      return 'Reply'
    }
    if (isEdit) {
      return 'Save changes'
    }
    return 'Comment'
  }

  return (
    <div className={cn(styles.wrapper, isEdit ? styles.editWrapper : styles.commentWrapper)}>
      {!isEdit && (
        <section>
          <Avatar />
        </section>
      )}
      <section className={styles.main}>
        <Textarea
          disabled={isLoading}
          onChange={e => {
            if (isAuthenticated) {
              updateText(e)
            }
          }}
          onFocus={() => {
            if (!isAuthenticated) {
              dispatch(routerActions.push(`${pathname}?modal=signup`))
            } else {
              handleCommentStart?.()
            }
          }}
          value={commentText}
          placeholder={`Write a ${isReply ? 'reply' : 'comment'}…`}
          className={styles.textarea}
          minRows={isEdit || isReply ? 1 : 2}
        />
        {isCommenting && (
          <div className={styles.actions}>
            {isEdit && (
              <Button onClick={handleCommentCancel} className={styles.cancel}>
                Cancel
              </Button>
            )}
            <Button
              disabled={!commentText || isLoading}
              isLoading={isLoading}
              onClick={() => onCommentDone(text)}
              className={styles.button}
            >
              {renderButtonText()}
            </Button>
          </div>
        )}
      </section>
    </div>
  )
}

export default AddComment
